import { render, staticRenderFns } from "./DiscountRulePreview.vue?vue&type=template&id=15acfabe&scoped=true&"
import script from "./DiscountRulePreview.vue?vue&type=script&lang=js&"
export * from "./DiscountRulePreview.vue?vue&type=script&lang=js&"
import style0 from "./DiscountRulePreview.vue?vue&type=style&index=0&id=15acfabe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15acfabe",
  null
  
)

export default component.exports